import { JsonObject, JsonProperty } from 'json2typescript';
import { GetActivitiesResponseInterface } from '../interfaces/getactivities-response.interface';
import { ActivitiesResponseModel } from './activities-response.model';

@JsonObject('GetActivitiesResponseModel')
export class GetActivitiesResponseModel implements GetActivitiesResponseInterface {
  Activities?: ActivitiesResponseModel[];

  constructor(obj?: any) {
    Object.assign(this, obj);
  }
}
